import toast from 'react-hot-toast';

class AppError extends Error {
  constructor(message: string, public code?: string) {
    super(message);
    this.name = 'AppError';
  }
}

class QuotaExceededError extends AppError {
  constructor(message: string = 'API Quota Exceeded') {
    super(message, 'QUOTA_EXCEEDED');
    this.name = 'QuotaExceededError';
  }
}

export class StorageFullError extends AppError {
  constructor(message: string = 'Browser storage is full') {
    super(message, 'STORAGE_FULL');
    this.name = 'StorageFullError';
  }
}

const parseErrorMessage = (err: any): string => {
  if (err instanceof StorageFullError) return err.message;
  if (err instanceof QuotaExceededError) return err.message;
  
  let errorMsg = err.message || (typeof err === 'object' && err !== null ? JSON.stringify(err, Object.getOwnPropertyNames(err)) : String(err));
  if (errorMsg === '[object Object]') {
    try {
      errorMsg = JSON.stringify(err);
    } catch(e) {}
  }
  
  const lowerErrorMsg = errorMsg.toLowerCase();
  
  if (lowerErrorMsg.includes('storage_quota_exceeded') || err.name === 'QuotaExceededError' || err.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
    return "Your browser storage is full. Please delete some saved workspaces or resumes to make space.";
  }
  
  if (lowerErrorMsg.includes('resource_exhausted') || lowerErrorMsg.includes('quota') || lowerErrorMsg.includes('rate limit') || lowerErrorMsg.includes('rate limits') || lowerErrorMsg.includes('429')) {
    return "Our job search service is currently experiencing high demand. Please try again in a few moments.";
  }

  // Handle json string blocks in error message
  if (errorMsg.includes('{"error"')) {
    try {
      const match = errorMsg.match(/\{"error".+\}/);
      if (match) {
        const parsed = JSON.parse(match[0]);
        if (parsed.error && parsed.error.status === 'RESOURCE_EXHAUSTED') {
          return "Our job search service is currently experiencing high demand. Please try again in a few moments.";
        }
        if (parsed.error && parsed.error.message) {
          return parsed.error.message;
        }
      }
    } catch(e) {}
  }
  
  return errorMsg;
};

export const handleAppError = (err: any, fallbackMessage: string = 'An error occurred') => {
  const msg = parseErrorMessage(err);
  toast.error(msg || fallbackMessage, {
    duration: 5000,
    id: msg, // Use the message as the ID to prevent spamming the same error
  });
  return msg || fallbackMessage;
};
